import { InvoiceStatus } from '#types';

export const InvoiceIsMutable = ( status: InvoiceStatus | undefined ) =>
	!status ||
	![
		InvoiceStatus.Disputed,
		InvoiceStatus.Hidden,
		InvoiceStatus.Void
	].includes(
		status
	);

export const InvoiceIsSendable = ( status: InvoiceStatus | undefined ) =>
	!status || ![ InvoiceStatus.Hidden, InvoiceStatus.Void ].includes( status );
